import makeStyles from '@mui/styles/makeStyles';
import type { Theme } from '@mui/material';

const createClasses = makeStyles({
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '13px'
  },
  dot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    display: 'inline-block'
  },
  online: {
    backgroundColor: '#4caf50'
  },
  offline: {
    backgroundColor: '#f44336'
  }
});

export const createNetworksTableClasses = makeStyles<Theme>(theme => ({
  roleFilterContainer: {
    display: 'flex',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1)
  }
}));

export const createSnackbarAlertClasses = makeStyles<Theme>(theme => ({
  alert: {
    margin: '0 auto',
    maxWidth: `924px !important`,
    padding: `${theme.spacing(1.5)} ${theme.spacing(2.5)} !important`,
    border: `1px solid ${theme.palette.divider} !important`,
    backgroundColor: `${theme.palette.background.paper} !important`,
    alignItems: 'center',
    '& .MuiAlert-icon': {
      marginRight: theme.spacing(2),
      padding: 0
    },
    '& .MuiAlert-message': {
      padding: `${theme.spacing(0.5)} 0`
    },
    '& .MuiAlert-action': {
      alignItems: 'center',
      paddingLeft: theme.spacing(2),
      marginRight: 0
    }
  },
  button: {
    marginRight: theme.spacing(3),
    whiteSpace: 'nowrap'
  }
}));

export default createClasses;
